import Project from "benchmarking-domain/project";
import * as React from "react";
import Button from "@mui/material/Button";
import {paths} from "../../../paths";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useOrganisation} from "../../../hooks/use-organisation";
import useApi from "../../../hooks/use-api";
import {enqueueSnackbar} from "notistack";

interface OrganisationArchiveButtonProps {
  organisationId: string;
}

export function OrganisationArchiveButton({organisationId}: OrganisationArchiveButtonProps): React.JSX.Element {
  const { archiveOrganisation } = useApi();
  const [openArchiveConfirmation, setOpenArchiveConfirmation] = React.useState(false);

  const handleOpenArchiveConfirmation = () => {
    setOpenArchiveConfirmation(true);
  };

  const handleClose = async (confirmed: boolean) => {
    if(confirmed) {
      await archiveOrganisation(organisationId);
      enqueueSnackbar('Organisation archiving started! It will disappear shortly.', { variant: 'success' });
    }

    setOpenArchiveConfirmation(false);
  };

  return (
    <>
      <Button variant="contained" color="warning" onClick={() => handleOpenArchiveConfirmation()}>Archive&nbsp;organisation</Button>
      <Dialog
        open={openArchiveConfirmation}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Archive organisation?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Organisation will be moved to archive and its data (inc. projects) will be available through a support request only.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Disagree</Button>
          <Button variant="contained" color={"warning"} onClick={() => handleClose(true)} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
